var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2787_102264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 7.14844C17.0354 7.14844 16.3262 8.00558 16.3262 8.86272C16.3262 9.71987 17.1772 10.577 18.0283 10.577C18.8794 10.577 19.7304 9.71987 19.7304 8.86272C19.7304 8.00558 19.0212 7.14844 18.0283 7.14844ZM18.0283 9.29129C17.8865 9.29129 17.7446 9.29129 17.7446 9.29129C17.6028 9.14844 17.4609 9.00558 17.4609 8.71987C17.4609 8.29129 17.7446 8.14844 18.0283 8.14844C18.312 8.14844 18.5957 8.43415 18.5957 8.71987C18.5957 9.00558 18.4538 9.29129 18.0283 9.29129Z",
    fill: "#2B343E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 6.00781C22 5.00781 21.1489 4.00781 20.0142 4.00781H5.26241H4.12766H3.98582C2.85106 4.00781 2 4.86496 2 6.00781V18.1507C2 19.2935 2.85106 20.0078 3.98582 20.0078H20.0142C20.8652 20.0078 21.7163 19.4364 22 18.5792V16.7221V6.00781ZM3.98582 19.0078C3.41844 19.0078 3.13475 18.5792 3.13475 18.1507V16.5792L7.8156 12.0078C8.09929 11.7221 8.24113 11.7221 8.52482 11.7221C8.66667 11.7221 8.95035 11.865 9.0922 12.0078L15.617 19.0078H3.98582ZM20.8652 18.0078C20.8652 18.5792 20.4397 18.865 20.0142 18.865H17.0355L13.6312 15.2935L15.7589 13.4364C16.0426 13.1507 16.6099 13.1507 16.8936 13.4364L20.8652 17.4364V18.0078ZM20.8652 16.0078L17.7447 12.865C17.3191 12.4364 16.8936 12.2935 16.3262 12.2935C15.7589 12.2935 15.3333 12.4364 15.0496 12.7221L12.922 14.5792L9.94326 11.2935C9.51773 10.865 9.0922 10.5792 8.52482 10.5792C8.09929 10.5792 7.53191 10.7221 7.10638 11.1507L3.13475 15.1507V6.00781C3.13475 5.43638 3.56028 5.15067 3.98582 5.15067H20.0142C20.5816 5.15067 20.8652 5.57924 20.8652 6.00781V16.0078Z",
    fill: "#2B343E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2787_102264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(2 4.00781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.776f4b1878c71d899e902ffb83f66191.svg";
export { ForwardRef as ReactComponent };